import { createRouter, createWebHistory } from 'vue-router'
import RunnerInput from '../components/RunnerInput.vue'
import TrackingView from '../components/TrackingView.vue'

const routes = [
  {
    path: '/',
    redirect: '/demo-event'
  },
  {
    path: '/:eventName',
    name: 'RunnerInput',
    component: RunnerInput,
    props: true
  },
  {
    path: '/:eventName/:runnerNumber',
    name: 'TrackingView',
    component: TrackingView,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router